export enum AddonInactiveMode {
    
    HIDDEN = "hidden",
    
    MINI = "mini"
}